import { colors } from '@EVOCORP/corechat-theme';
import {
  Box,
  Container,
  ListItem,
  makeStyles,
  Paper,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Error } from '@material-ui/icons';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import clsx from 'clsx';
import dayjs from 'dayjs';

import { MessageBaseProps } from './MessageBase';

const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  root: ({ fromMe }: MessageBaseProps) => {
    const justify = fromMe ? 'flex-end' : 'flex-start';

    return {
      justifyContent: justify,
    };
  },
  container: {
    margin: 0,
    width: 'auto',
    position: 'relative',
    maxWidth: '336px',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    justifyContent: 'space-between',
    color: palette.text.primary,
    minHeight: 24,
  },

  contentMessage: ({ fromMe }: MessageBaseProps) => {
    const bg = fromMe ? colors.light.primary.dark : palette.background.tertiary;
    const color = palette.error.main;
    const borderRadius = fromMe ? spacing(1, 1, 0, 1) : spacing(0, 1, 1, 1);

    return {
      overflow: 'hidden',
      position: 'relative',
      padding: spacing(1),
      color,
      backgroundColor: bg,
      borderRadius,
      display: 'flex',
      alignItems: 'center',
      gridGap: spacing(1),
    };
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    margin: '4px 0 -5px 4px',
    userSelect: 'none',
    fontSize: typography.pxToRem(10),
  },
}));

export default function MessageErrorFallback({
  fromMe,
  mensagem,
  autor,
  autorColor,
}: MessageBaseProps) {
  const classes = useStyles({ fromMe } as MessageBaseProps);

  return (
    <ListItem className={classes.root} dense>
      <Container
        className={classes.container}
        disableGutters
        maxWidth={false}
        onClick={e => e.stopPropagation()}
      >
        <Box component="header" className={classes.header}>
          <Box pr={2} overflow="hidden" maxWidth="24ch" flexGrow={1}>
            <Typography
              title={autor}
              style={{ fontWeight: 'bold', color: autorColor || 'inherit' }}
              variant="caption"
              component="div"
              noWrap
            >
              {autor}
            </Typography>

            <Box fontStyle="italic">
              {mensagem?.isEncaminhada && (
                <Typography variant="caption" color="textSecondary">
                  Encaminhada
                </Typography>
              )}
            </Box>
          </Box>
        </Box>

        <Paper
          elevation={0}
          component="main"
          className={clsx(classes.contentMessage)}
        >
          <Error fontSize="small" />
          Não foi possível exibir esta mensagem
        </Paper>

        {mensagem?.criadoEm && (
          <Box className={classes.footer} component="footer">
            <Tooltip
              arrow
              placement="bottom"
              title={dayjs(mensagem.criadoEm).format(
                'D [de] MMM [de] YYYY [às] HH:mm',
              )}
            >
              <Typography variant="inherit" color="textSecondary">
                {dayjs(mensagem.criadoEm).format('HH:mm')}
              </Typography>
            </Tooltip>

            {fromMe && (
              <Box marginLeft="3px">
                <AccessTimeIcon fontSize="small" color="disabled" />
              </Box>
            )}
          </Box>
        )}
      </Container>
    </ListItem>
  );
}
